import { render, staticRenderFns } from "./SignUpValidation.vue?vue&type=template&id=39e6a6a2&"
import script from "./SignUpValidation.vue?vue&type=script&lang=js&"
export * from "./SignUpValidation.vue?vue&type=script&lang=js&"
import style0 from "./SignUpValidation.vue?vue&type=style&index=0&id=39e6a6a2&prod&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports